import React, { useState } from "react"
import { NavLink } from "react-router-dom"
import "./CNavbar.css"
import { HamburgetMenuClose, HamburgetMenuOpen } from "./Icons"

function CNavbar() {

  const [click, setClick] = useState(false)
  const handleClick = () => setClick(!click)

  return (
    <>
      <nav className="cunavbar">
        <div className="nav-container">
          <NavLink exact to="/" className="navbar-logo">
            <img src="./HomePhotos/Navbar/avenueonelogo.png" alt="LOGO" />
          </NavLink>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <NavLink
                exact
                to="/"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                HOME
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/square"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                Square
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/park"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                PARK
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/swissresidencies"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                SWISS RESIDENCIES
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink
                to="/orchird"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                ORCHIRD
              </NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink
                to="/gallery"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                GALLERY
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/about"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                ABOUT
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/contact"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                CONTACT
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/bookapartment"
                activeClassName="active"
                className="nav-link-bold bg-[#B2A367] p-3 rounded-lg text-[#24272D] font-bold hover:bg-[#24272D] hover:border-2 hover:border-white hover:text-white"
                onClick={handleClick}
              >
                Book Your Apartment
              </NavLink>
            </li>
          </ul>
          <div className="nav-icon" onClick={handleClick}>
            {click ? (
              <span className="icon">
                <HamburgetMenuClose />
              </span>
            ) : (
              <span className="icon">
                <HamburgetMenuOpen />
              </span>
            )}
          </div>
        </div>
      </nav>
    </>
  )
}

export default CNavbar